import DiscussionItem from './DiscussionItem';

export default DiscussionItem;
